import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import withRouter from "components/Common/withRouter";
import Loader from "../../components/Loader/Loader";
import refreshResourcesLottie from '../../assets/images/refresh_resources_lottie.json';
import {Col, Container, Modal, ModalHeader, Row,} from "reactstrap";
import {Link} from "react-router-dom";

// Pages Components
import LatestTranaction from "./SplunkServiceDependency";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//import {} from "../../store/actions";


//i18n

const SplunkServiceDependency = props => {
    const dispatch = useDispatch();

    const [splunkSubmitDeployModal, setSplunkSubmitDeployModal] = useState(false);

    const handleSubmit = () => {
        setSplunkSubmitDeployModal(true);
    }

    const cancelDeployModal = () => {
        setSplunkSubmitDeployModal(false);
    }

    const handleRefresh = () => {
        //dispatch(onGetAwsRefresh());
    }

    const [splunkRefreshModal, setSplunkRefreshModal] = useState(false);

    // const {isNewRelicRefreshing} = useSelector(state => ({
    //     isNewRelicRefreshing: state.Dashboard.is_new_relic_refreshing,
    // }));
    //
    // useEffect(() => {
    //     if (isNewRelicRefreshing) {
    //         setDatadogRefreshModal(true);
    //     } else {
    //         setTimeout(() => {
    //             setDatadogRefreshModal(false);
    //         }, 4000);
    //     }
    // }, [isNewRelicRefreshing]);

    //meta title
    document.title = "SplunkServiceDependencyResource | Temperstack";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Row>
                        <Col lg="8">
                            <Breadcrumbs
                                title={"Splunk Service Dependency Resources"}
                                breadcrumbItem={"Splunk Service Dependency Resources"}
                            />
                        </Col>
                        <Col lg="4">
                        </Col>
                        <Col lg="12">
                            <LatestTranaction/>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Loader
                isOpen={splunkRefreshModal}
                lottieJson={refreshResourcesLottie}
                messageHeader="Scanning Splunk"
                message="Please wait while we scan your Splunk universe for new resources."
            />

            <Modal
                isOpen={splunkSubmitDeployModal}
                role="dialog"
                autoFocus={true}
                keyboard={false}
                centered
                backdrop="static"
                data-toggle="modal"
            >
                <div>
                    <ModalHeader
                        className="border-bottom-0"
                    ></ModalHeader>
                </div>
                <div className="modal-body">
                    <div className="text-center mb-4">
                        <div className="row justify-content-center">
                            <div className="col-xl-10">
                                <h4 className="text-primary">Are you sure you want to deploy alerts?</h4>
                                <h5 className="mt-4">This will deploy the default thresholds for all your resources. Please review
                                    the <Link to="/thresholds" target="_blank">thresholds</Link> and modify if required.</h5>
                                <Row className="full-width">
                                    <Col lg="6" className="mt-4">
                                        <Link onClick={cancelDeployModal} className="btn btn-secondary w-md">Cancel</Link>
                                    </Col>
                                    <Col lg="6" className="mt-4">
                                        <Link to="/dashboard" className="btn btn-primary w-md">Deploy</Link>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    );
};

SplunkServiceDependency.propTypes = {
    history: PropTypes.object
};

export default withRouter(SplunkServiceDependency);
